module.exports = __webpack_public_path__ + "static/sport/mobile-bg.271f67b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/mobile-bg.jpg
// module id = LFZW
// module chunks = 0